import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { addAgentCode, redirectToHome, redirectToOld } from '__utils/common-utils';
import { LayoutContext } from 'components/app-routes';
import { isMintproApp } from '__utils/common-utils';
import moment from 'moment';
import { ENDPOINTS } from 'constants/endpoints';
import resolveURLParams from '__utils/url-params-resolver';
import { getQueryParamsFromString } from '__utils/common-utils';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import { WhiteCardWrapper } from 'views/common-styled-components';

const Challan: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const [ depositDate, setDepositDate ] = useState<string>('');
    const [ fileName, setFileName ] = useState<any>();
    const [ fileUrl, setFileUrl ] = useState<any>();
    const [ fileType, setFileType ] = useState<any>();
    const [ challanUrl, setChallanUrl ] = useState<any>();
    const { encryptedGroupId } = getQueryParamsFromString(window.location.search);
    const flash = useFlashToggler();
    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: `Challan`
            },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Challan', url: '/challan', isExternal: true } ]
        });
        calcualteDepositDate();
        generateChallan();
    }, []);

    const calcualteDepositDate = () => {
        const thresholdDate = moment();
        thresholdDate.set({
            hour: 15,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        if (moment() < thresholdDate)
        {
            setDepositDate(moment().format('LL'));
        }
        else
        {
            setDepositDate(moment().add(1, 'days').format('LL'));
        }
    }


    const generateChallan = () => {
        const GET_CHALLAN_API = isMobile ? ENDPOINTS.GET_CHALLAN_MOBILE : ENDPOINTS.GET_CHALLAN;
        encryptedGroupId && get(resolveURLParams(GET_CHALLAN_API, { groupId: encryptedGroupId }, null),
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            if (response.status)
            {
                if (isMobile)
                {
                    setFileName(response);
                    setFileUrl(response);
                    setFileType(response?.response?.responseData?.fileTtype);
                }
                else
                {
                    setChallanUrl(response?.response?.responseData?.challanUrl);
                }
            }
        }, (error: AjaxError) => {
            flash.error("Something went wrong. Please try again later.")
        });
    }

    const downloadChallan = () => {
        if (isMobile && isMintproApp())
        {
            var featurePayload = {
                type: 'download',
                payload: {
                    fileName: fileName,
                    fileUrl: fileUrl,
                    fileType: fileType,
                },
            };
            window.postMessage(JSON.stringify(featurePayload), '*');
        }
        else
        {
            window.open(challanUrl, '_blank')?.focus();
        }
    }

    return (
        <WhiteCardWrapper isMobile={ isMobile }>
            {/* cheque payment start */ }
            <div>
                <div className=" p15">
                    {
                        challanUrl ? <div className="chalanContent">
                            <label>Your challan has been generated.</label>
                            <button onClick={ downloadChallan } className="noborder greenBtn">DOWNLOAD CHALLAN</button>
                            </div>
                            :
                            <div className="chalanContent">
                                <label>Unable to download challan. Please refresh after sometime.</label>
                            </div>
                        
                    }
                    <br/>
                    <div className="chalanContent">
                        <label>Next steps to complete payment</label>
                        <div className={ isMobile ? "" : "challan-flex" }>
                            <div className="stepChln">
                                <span className="dot stepLine"></span> <b>Step 1</b>
                                <p>Download payment challan.</p>
                            </div>
                            <div className="stepChln">
                                <span className="dot stepLine"></span> <b>Step 2</b>
                                { depositDate && <p>Deposit both cheque and challan in the nearest Axis Bank branch before branch closure on { depositDate }. If { depositDate }  is a bank holiday, please deposit latest by next working day of the bank.</p> }
                            </div>
                            <div className="stepChln">
                                <span className="dot"></span> <b>Step 3</b>
                                <p>You can track the payment status from the dashboard by visiting the profile section.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WhiteCardWrapper>)
}

export default Challan;